import * as v from 'valibot';

const DocumentStatus = v.picklist([
	'Processing',
	'Completed',
	'Validation Error',
	'Process Error',
	'Document Approval Required',
	'Incorrect Document',
	'Incorrect Document Date',
]);
export type DocumentStatus = v.InferOutput<typeof DocumentStatus>;

const FileProgress = v.array(
	v.object({
		description: v.string(),
		progress: v.number(),
	}),
);

export const Documents = v.array(
	v.object({
		documentId: v.string(),
		documentTypeId: v.string(),
		financialYearEnd: v.optional(v.string()),
		financialYearStart: v.optional(v.string()),
		isOrphaned: v.boolean(),
		mimeType: v.string(),
		name: v.string(),
		size: v.number(),
		uploadDate: v.string(),
		documentStatus: DocumentStatus,
		fileProgress: v.optional(FileProgress),
	}),
);

export type Documents = v.InferOutput<typeof Documents>;

export type DocumentBody = {
	fileId: string;
	type: string;
	financialYearStart: string;
	financialYearEnd: string;
	documentYear: string;
	documentType: string;
	isDocumentApprovalRequired: boolean;
};

export const PutDocumentResponse = v.variant('success', [
	v.object({
		success: v.literal(true),
	}),
	v.object({
		success: v.literal(false),
		error: v.string(),
	}),
]);

export type PutDocumentResponse = v.InferOutput<typeof PutDocumentResponse>;
